import React from 'react';
import NavBar from ".././pageChild/NavBar";
import Intagram from ".././pageChild/Intagram";
import Footer from ".././pageChild/Footer";
import End from ".././pageChild/End";
import Products from ".././pageChild/Products";
import callApi from './../../utils/apicaler';
import Filter from './../pageXemthem/Filter';
import axios from 'axios';
import {
  Link
} from "react-router-dom";
 
class Thoitrang extends React.Component{
  constructor(props){
            super(props);

            this.state = {
                redirct:0,
                products:[],
                loader:"",
                carts:[],
                cartId:0,
                start:0,
                end:9,
                status:0
            }
        }

        componentDidMount(){
            {this.apiExpress()}
          var cart = JSON.parse(sessionStorage.getItem('products'));
          this.setState({carts:cart})
            if(cart === null){
                console.log("!")
            }else{
                cart.map((carts, index)=>{
                    this.setState({cartId: index + 1})
                })
            }
        }

        apiExpress = () =>{
            callApi('5f1b03fe6c6c7f0072c612af', 'GET', null).then(res =>{
                let {start, end} = this.state;
                this.setState({
                    redirct : res.status,
                    products : res.data
                })
            })
        }

        addSplice = () =>{
            let {end} = this.state;
            this.setState({end: end+3})
        }
        
        showTable = (datas, status) =>{
            var result = null;
                result = datas.map((product, index)=>{
                    return ( product.conten === "Thời trang" ?
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-3" style={{paddingRight:"6px", paddingLeft: "6px"}} key={index}>
                            <Link to={`product/${product._id}`}>
                                <div className="colection1" >
                                {product.sale === "HET HANG" ? <p style={{background:"red"}}>Hết hàng</p> : product.sale === "SALE" ? <p style={{background:"red"}}>{`Sale ${product.salePrice}`}</p> : <p>New</p>}
                                
                                <img src={product.imgeFile} />

                                </div>
                                <div className="title_product">
                                <b>{product.products.slice(0,28)}...</b>
                                <hr/>
                                {product.sale === "SALE" ? 
                                <span>
                                <span style={{textDecoration: product.sale === "SALE" ? "line-through" : ""}}>{product.price}.000 Vnd</span>
                                <br/>
                                <b style={{fontSize:"17px", color:"red"}}>{((parseInt(product.price)*(1 - parseInt(product.salePrice)/100.0)))}.000VND</b>
                                </span>
                                :
                                <span>{product.price}.000VND</span>
                                }
                            </div>
                            </Link>
                        </div> 
                        : 
                        ""
                    )
                })
            return result
        }
  render(){
    const {products, redirct, loader,cartId, start, end, status} = this.state;


    var wapper = <div style={{background:"rgb(231, 239, 247)"}} className={`container-fluid custom_fluid ${loader}`}>
                    <div className="row custom_row">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                        <NavBar cartId={cartId} />
                      </div>
                    </div>
                   <div className="row custom_row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                            <div className="cart_img thoitrang"></div>
                        </div>
                    </div>

                    <div className="row custom_row">
                        <div className="title_pay">
                            <h3>ThỜI TRANG</h3>
                            <div className="deb" style={{textAlign:"center"}}>
                                
                            <hr/>
                            </div>
                        </div>
                        <div className="box_main">
                            {this.showTable(products, status)}
                        </div>
                    </div>
                    <div className="send_mail">
                        <button type="button" onClick={this.addSplice}>XEM THEM</button>
                    </div>
                    <Intagram />
                    <Footer />
                    <End />
                </div>
      return ( 
            <div>
                { redirct === 200 ? wapper : <div className="loader loader-black loader-1"></div>}
            </div>
     
              
  
        )
      }
  }
export default Thoitrang;